import React from 'react';
import "./blog.css";

const ContentPage = () => {
  return (
    <section id="content-page-blog">
      <div className="cs-container">
        <div className="cs-content">
          <h1 className="cs-title">
            How to Build a Website for Small Businesses in New Zealand That <span className="cs-color">Doesn't Suck</span>
          </h1>
          <p>
            Optimizing for Kiwis, Google, and the future is no small task. If you want to stand out in the New Zealand small business space, you can't just slap a site together. You've got to be strategic. Here’s the real stuff that matters when it comes to building websites that work for Kiwi small businesses.
            <br></br><br></br>
            From cultural shifts to Google ranking changes, optimizing a small business website is about more than just pretty design. It’s about staying relevant, and here’s how to do it.
          </p>    

          <h3>1. Cultural Shifts Are Your New Best Friend</h3>
          <p>
            New Zealand is evolving quickly. Local businesses need to embrace trends like buying local, sustainability, and supporting Māori businesses. Integrating elements like Te Reo Māori in your design not only showcases inclusivity but also builds customer trust.
          </p>
          
          <h3>2. Recent Google Ranking Changes Are A Big Deal</h3>
          <p>
            Google now focuses heavily on Core Web Vitals—load time, interactivity, and visual stability. With mobile-first indexing and New Zealanders increasingly using smartphones, ensuring a website is mobile-friendly is critical. A slow site equals lost business. Use Google PageSpeed Insights to keep performance in check.
          </p>
          
          <h3>3. Google My Business – Don’t Sleep On This</h3>
          <p>
            Google My Business (GMB) is now essential for local search ranking. Ensure that the business profile is fully optimized with accurate operating hours, reviews, and local keywords. GMB can make or break local SEO efforts.
          </p>
          
          <h3>4. Content is King, But Quality is the Crown</h3>
          <p>
            High-quality, relevant content drives engagement. Blogs, customer success stories, and videos all contribute to better user experience and SEO. Link the content to what’s happening locally in New Zealand to stay relevant and drive community involvement.
          </p>
                    
          <h2>Conclusion: Optimize for the Future</h2>
          <p>
            Websites for small businesses in New Zealand need to embrace local cultural trends, stay on top of Google’s algorithm changes, and prioritize user experience. From ensuring mobile-first design to leveraging GMB for local SEO, building for the future is all about optimizing for speed, security, and content quality.
          </p>
          <a 
              href="/"
              className="cs-button-solid"
              aria-label="Learn more about our hand-coded small business website design service"
              title="Hand-coded small business websites in Auckland and across New Zealand"
          >
              Small Business Website Package →
          </a>

        </div>

        <div className="cs-image-group">
          <picture className="cs-picture">
            {/* Mobile Image */}
            <source
              media="(max-width: 600px)"
              srcSet="./nzblogpost.webp"
            />
            {/* Tablet and above Image */}
            <source
              media="(min-width: 601px)"
              srcSet="./nzblogpost.webp"
            />
            <img
              decoding="async"
              src="./nzblogpost.webp"
              alt="performance car"
              width="542"
              height="520"
              aria-hidden="true"
            />
          </picture>
        </div>
      </div>
    </section>
  );
};

export default ContentPage;
